import { IPublicClientApplication } from '@azure/msal-browser';
import { NominationWebsite } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { createNominationWebsite, deleteNominationWebsite, updateNominationWebsite } from './index';

export const createNominationWebsitesApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  createNominationWebsite: (instance: IPublicClientApplication, nominationId: number, nominationWebsite: NominationWebsite) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => createNominationWebsite(fetchContext, nominationId, nominationWebsite, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('createNominationWebsite', isInFlight);
    },
  ),
  updateNominationWebsite: (instance: IPublicClientApplication, nominationWebsite: NominationWebsite) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateNominationWebsite(fetchContext, nominationWebsite, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateNominationWebsite', isInFlight);
    },
  ),
  deleteNominationWebsite: (instance: IPublicClientApplication, websiteId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => deleteNominationWebsite(fetchContext, websiteId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('deleteNominationWebsite', isInFlight);
    },
  ),
});
